<template>
  <div class="d-flex flex-column align-items-center">
    <h2>Mehr Informationen: {{ servicekleber.tib.name }}</h2>
    <div>{{ servicekleber.address.tib.name }}
      {{ servicekleber.address.data.address }},
      {{ servicekleber.address.data.city }}</div>

    <button class="mt-3" v-if="!detailsVisible"
      type="button"
      @click="showDetails(true)"
    >
      <span aria-hidden="true">Details</span>
    </button>

    <div v-if="detailsVisible">
      <div class="modal-dialog modal-xl mt-3" role="document" >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Details</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="showDetails(false)"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <label for="name">Name</label>
                <input readonly
                  ref="nameInput"
                  type="text"
                  class="form-control"
                  id="name"
                  placeholder="name"
                  v-model="servicekleber.tib.name"
                />
              </div>
              <div class="form-group">
                <label for="tenant">Mandant</label>
                <input readonly
                  type="text"
                  class="form-control"
                  id="tenant"
                  placeholder="tenant"
                  v-model="servicekleber.data.tenant"
                />
              </div>
              <div class="form-group">
                <label for="floor">Stockwerk</label>
                <input readonly
                  type="text"
                  class="form-control"
                  id="floor"
                  placeholder="floor"
                  v-model="servicekleber.data.floor"
                />
              </div>
              <div class="form-group">
                <label for="deviceLocation">Standort Details</label>
                <input readonly
                  type="text"
                  class="form-control"
                  id="deviceLocation"
                  placeholder="deviceLocation"
                  v-model.trim="servicekleber.data.deviceLocation"
                />
              </div>
              <div class="form-group">
                <label for="manufacturer">Hersteller</label>
                <input readonly
                  type="text"
                  class="form-control"
                  id="manufacturer"
                  placeholder="manufacturer"
                  v-model.trim="servicekleber.data.manufacturer"
                />
              </div>
              <div class="form-group">
                <label for="deviceName">Gerätename</label>
                <input readonly
                  type="text"
                  class="form-control"
                  id="deviceName"
                  placeholder="deviceName"
                  v-model.trim="servicekleber.data.deviceName"
                />
              </div>
              <div class="form-group">
                <label for="deviceType">Gerätetyp</label>
                <input readonly
                  type="text"
                  class="form-control"
                  id="deviceType"
                  placeholder="deviceType"
                  v-model.trim="servicekleber.data.deviceType"
                />
              </div>
              <div class="form-group">
                <label for="serialNumber">Seriennummer</label>
                <input readonly
                  type="text"
                  class="form-control"
                  id="serialNumber"
                  placeholder="serialNumber"
                  v-model.trim="servicekleber.data.serialNumber"
                />
              </div>
              <div class="form-group">
                <label for="deviceNumber">Typennummer</label>
                <input readonly
                  type="text"
                  class="form-control"
                  id="deviceNumber"
                  placeholder="deviceNumber"
                  v-model.trim="servicekleber.data.deviceNumber"
                />
              </div>
              <div class="form-group">
                <label for="addOns">Zusatzgeräte</label>
                <input readonly
                  type="text"
                  class="form-control"
                  id="addOns"
                  placeholder="addOns"
                  v-model.trim="servicekleber.data.addOns"
                />
              </div>
              <div class="form-group">
                <label for="payAccount">QR Zahlfunktion Firma (payAccount)</label>
                <input readonly
                  type="text"
                  class="form-control"
                  id="payAccount"
                  placeholder="payAccount"
                  v-model.trim="servicekleber.tib.attributesMap.payAccount"
                />
              </div>
              <div class="form-group">
                <label for="regId">QR Zahlfunktion Referenz (regId)</label>
                <input readonly
                  type="text"
                  class="form-control"
                  id="regId"
                  placeholder="regId"
                  v-model.trim="servicekleber.tib.attributesMap.regId"
                />
              </div>
              <div class="form-group">
                <label for="tag">Tag</label>
                <input readonly
                  type="text"
                  class="form-control"
                  id="tag"
                  placeholder="tag"
                  v-model.trim="servicekleber.tib.tag"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <h2 class="mt-3" v-if="servicekleber.address.tibs.length + servicekleber.tibs.length > 0">{{ tp.tibs }}</h2>

    <div
      class="row mx-auto"
      v-for="(tib, index) in servicekleber.address.tibs"
      :key="index"
    >
      <tibView :tibModelProperty="tib" :tp="tp"> </tibView>
    </div>
    <hr />
    <div
      class="row mx-auto"
      v-for="(tib, index) in servicekleber.tibs"
      :key="index"
    >
      <tibView :tibModelProperty="tib" :tp="tp"> </tibView>
    </div>
  </div>
</template>

<script>
import tibView from "@/components/TibView.vue";
export default {
  name: "servicekleberTibsView",
  components: {
    tibView
  },
  data: function() {
    return {
      servicekleber: this.servicekleberProperty,
      detailsVisible: false
    };
  },
  mounted() {
    this.servicekleber = this.servicekleberProperty;
  },
  watch: {
    servicekleberProperty() {
      this.servicekleber = this.servicekleberProperty;
    }
  },
  methods: {
    showDetails(on) {
      this.detailsVisible = on;
    }

  },
  props: {
    servicekleberProperty: Object,
    tp: Object
  }
};
</script>
